export const filter = {
    id: "",
    name: "",
    // code: "",
    search: "",
    created_at: "",
    updated_at: "",
};
